export type LatLng = {
    lat: number;
    lng: number;
};

export type Address = {
    firstname?: string;
    lastname?: string;
    company?: string;
    street: string;
    zipcode: string;
    city: string;
    country: string;
    coordinates: LatLng;
    viewportNE: LatLng;
    viewportSW: LatLng;
};

export const createEmptyAddress = () => {
    return {
        street: '',
        zipcode: '',
        city: '',
        country: '--',
        coordinates: {
            lat: 0,
            lng: 0,
        },
        viewportNE: {
            lat: 0,
            lng: 0,
        },
        viewportSW: {
            lat: 0,
            lng: 0,
        },
    };
};
